import { render, staticRenderFns } from "./EstimatesOldPageMaterialRow.vue?vue&type=template&id=3c290856&"
import script from "./EstimatesOldPageMaterialRow.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageMaterialRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports